<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBWarehouseItemForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBWarehouseItemList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBWarehouseItemForm from './Form.vue'

export default {
  components: {
    EXSBWarehouseItemForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbwarehouseitem/update/isLoading',
      error: 'exsbwarehouseitem/update/error',
      deleteError: 'exsbwarehouseitem/del/error',
      deleteLoading: 'exsbwarehouseitem/del/isLoading',
      created: 'exsbwarehouseitem/create/created',
      deleted: 'exsbwarehouseitem/del/deleted',
      retrieved: 'exsbwarehouseitem/update/retrieved',
      updated: 'exsbwarehouseitem/update/updated',
      violations: 'exsbwarehouseitem/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBWarehouseItemList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbwarehouseitem/create/reset',
      deleteItem: 'exsbwarehouseitem/del/del',
      delReset: 'exsbwarehouseitem/del/reset',
      retrieve: 'exsbwarehouseitem/update/retrieve',
      updateReset: 'exsbwarehouseitem/update/reset',
      update: 'exsbwarehouseitem/update/update',
      updateRetrieved: 'exsbwarehouseitem/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbwarehouseitem ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
